import { Component, OnInit, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: '[app-ctl-list-view]',
  templateUrl: './ctl-project-list.component.html',
  styleUrls: ['./ctl-project-list.component.css']
})
export class CtlProjectListComponent implements OnInit {
  @Output()
  toggleDataEvent: EventEmitter<object> = new EventEmitter();

  @Output()
  editDataEvent: EventEmitter<object> = new EventEmitter();

  @Output()
  viewDataEvent: EventEmitter<object> = new EventEmitter();
  @Output()
  viewDataNewUserRequestEvent: EventEmitter<object> = new EventEmitter();

  showicon = 'inline';

  ctlData = {};
  @Input() dataIconColor = {
    stringToColorHash: {},
    nextVeryDifferntColorIdx: 63,
    veryDifferentColors: [
      '#000000', '#00FF00', '#0000FF', '#FF0000', '#01FFFE', '#FFA6FE',
      '#FFDB66', '#006401', '#010067', '#95003A', '#007DB5', '#FF00F6',
      '#FFEEE8', '#774D00', '#90FB92', '#0076FF', '#D5FF00', '#FF937E',
      '#6A826C', '#FF029D', '#FE8900', '#7A4782', '#7E2DD2', '#85A900',
      '#FF0056', '#A42400', '#00AE7E', '#683D3B', '#BDC6FF', '#263400',
      '#BDD393', '#00B917', '#9E008E', '#001544', '#C28C9F', '#FF74A3',
      '#01D0FF', '#004754', '#E56FFE', '#788231', '#0E4CA1', '#91D0CB',
      '#BE9970', '#968AE8', '#BB8800', '#43002C', '#DEFF74', '#00FFC6',
      '#FFE502', '#620E00', '#008F9C', '#98FF52', '#7544B1', '#B500FF',
      '#00FF78', '#FF6E41', '#005F39', '#6B6882', '#5FAD4E', '#A75740',
      '#A5FFD2', '#FFB167', '#009BFF', '#E85EBE']
  };

  @Input() dataView;
  @Input() dataType;
  @Input() title = 'null';
  @Input() desc = 'null';
  @Input() description = 'null';
  @Input() extrainfo1 = 'null';
  @Input() extrainfo2 = 'null';

  @Input() extrainfo5 = 'null';
  @Input() extrainfo6 = 'null';
  @Input() extrainfo7 = 'null';
  @Input() extrainfo8 = 'null';
  @Input() extrainfo3 = 'null';
  @Input() extrainfo4 = 'null';
  @Input() vextrainfo1 = 'null';
  @Input() vextrainfo2 = 'null';
  @Input() vextrainfo3 = 'null';

  @Input() moreinfo = 'null';
  @Input() cinfo1 = 'null';
  @Input() info1 = 'null';
  @Input() info2 = 'null';
  @Input() uinfo = 'null';

  @Input() info3 = 'null';
  @Input() info4 = 'null';
  @Input() info5 = 'null';
  @Input() info6 = 'null';
  @Input() location = 'null';
  @Input() count;
  @Input() countInfo;
  @Input() status: boolean;
  @Input() requestStatus = 'null';
  @Input() objId;
  @Input() email = 'null';
  @Input() logo: string;
  @Input() showlogo = 'false';
  @Input() loopIndex;
  @Input() action = 'yes';
  @Input() row: boolean;
  constructor() { }

  ngOnInit(): void {
    if (this.status){
      this.row = this.status;
    }
  }

  toggleData(obj) {
    this.toggleDataEvent.emit(obj);
  }

  editData(obj) {
    this.editDataEvent.emit(obj);
  }

  overviewData(obj) {
    this.viewDataEvent.emit(obj);
  }

  overviewNewUserData(obj) {
    this.viewDataNewUserRequestEvent.emit(obj);
  }

  emailData(obj) {
    window.location.href = 'mailto:' + obj.email;
  }

  tabHeadingInitial(data){
    let temp1;
    let temp2;
    if (data !== undefined)
    {
      const temp = data.split(' ');
      temp1 = temp[0].charAt(0).toUpperCase();
      if (temp.length > 1) {
        temp2 = temp[1].charAt(0).toLowerCase();
      } else {
        temp2 = temp[0].charAt(1).toUpperCase();
      }
    }
    return temp1 + temp2;
  }

  randomNumber(num, status){
    let cssNum;
    if (status === true){
        cssNum = num;
    }else{
       cssNum = 6;
    }
    return cssNum;
  }

  randomNumber1(status) {
    let  cssNum;
    if (status === true) {
      cssNum = Math.floor((Math.random() * 5) + 1);
    } else {
        cssNum = 6;
    }
    const temp = 'circle-text-' + cssNum;
    return temp;
  }

  setIconColor(str, status) {
    str = this.tabHeadingInitial(str);
    if (!this.dataIconColor.stringToColorHash[str]) {
      this.dataIconColor.stringToColorHash[str] = this.dataIconColor.veryDifferentColors[this.dataIconColor.nextVeryDifferntColorIdx--];
      if (this.dataIconColor.nextVeryDifferntColorIdx === 0 ) {
        this.dataIconColor.nextVeryDifferntColorIdx = 63;
      }
    }
    return { 'background-color': this.dataIconColor.veryDifferentColors[0]};
  }
}
